module.exports = __webpack_public_path__ + "img/brightcove_options.5454855c.svg";